export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading">
              APP下载
            </h2>
            <p className="mt-4 text-base md:text-lg text-primary-100 leading-relaxed max-w-lg mx-auto lg:mx-0">
              下载虫虫漫画网APP，随时随地畅享<strong className="text-background-50">免费漫画</strong>阅读体验。支持离线下载、夜间模式、智能推荐，让<strong className="text-background-50">好看的漫画</strong>触手可及。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-primary-600 font-semibold rounded-xl hover:bg-background-100 transition-all duration-200 whitespace-nowrap text-center cursor-pointer text-sm"
              >
                <i className="ri-apple-fill mr-2"></i>App Store 下载
              </a>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-600 text-background-50 font-semibold rounded-xl hover:bg-primary-700 border border-primary-400/40 transition-all duration-200 whitespace-nowrap text-center cursor-pointer text-sm"
              >
                <i className="ri-android-fill mr-2"></i>Android 下载
              </a>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-4 justify-center lg:justify-start text-primary-100 text-sm">
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-300"></i> 离线下载
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-300"></i> 夜间模式
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-300"></i> 推送提醒
              </span>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative w-[220px] h-[440px] md:w-[260px] md:h-[500px] rounded-3xl overflow-hidden bg-primary-600 border-4 border-primary-400/30">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20a%20manga%20comic%20reading%20app%20interface%20on%20screen%2C%20colorful%20manga%20covers%20displayed%20in%20grid%20layout%2C%20warm%20red%20and%20orange%20accent%20UI%20design%2C%20clean%20modern%20mobile%20app%20aesthetic%2C%20minimal%20phone%20frame%2C%20digital%20reading%20platform%20mockup&width=520&height=1000&seq=app-mockup-manga-2026&orientation=portrait"
                alt="虫虫漫画网APP - 随时随地免费看漫画"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}